export class CustomMessage {
    id: number;
    description: string;
    icon: string;
    from: Date;
    to: Date;
    active: boolean;
    apies: number;
    source: string
}